import o,{keyframes as e,css as t}from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as a}from"../../../theme/index.js";const r=e`
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
`,s=e`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(100%);
  }
`,n=o.aside`
  position: fixed;
  z-index: ${a.theme.zIndex.modal};
  top: -1px;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% + 1px);
  background-color: ${a.theme.colorVariables.bgPrimary};
  overflow-y: auto;
  overscroll-behavior: contain;
  animation: 0.3s ${r} ease-in-out;
  animation-fill-mode: forwards;

  ${a.theme.mixin.scroll}

  ${o=>o.isStartClose&&t`
      animation: 0.3s ${s} ease-in-out;
      animation-fill-mode: forwards;
    `};
`;n.defaultProps=a;export{n as Aside};
